export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location);
  // Don't update scroll position on certain pages
  // @NOTE This is just an internal function I run, so stub in your own logic here
  window.scrollTo(...(currentPosition || [0, 0]));
};
